import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=bf9b6f8c&scoped=true"
import script from "./CourseEdit.vue?vue&type=script&lang=js"
export * from "./CourseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9b6f8c",
  null
  
)

export default component.exports